module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formenu"
  }, [_c('div', {
    staticClass: "indexmenu"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "realmenu"
  }, [_c('li', {
    staticClass: "mm",
    attrs: {
      "data-menu": "m_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('about')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/1.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mm",
    attrs: {
      "data-menu": "m_06"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('product')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/2.png")
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "mm",
    attrs: {
      "data-menu": "m_02"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('artist')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/4.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mm",
    attrs: {
      "data-menu": "m_03"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('start')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/5.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mm",
    attrs: {
      "data-menu": "m_04"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('support')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/6.png")
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "mm",
    attrs: {
      "data-menu": "m_05"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('contact')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/9.png")
    }
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('a', {
    staticClass: "scroll",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goAbout()
      }
    }
  }, [_c('p', [_vm._v("scroll")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maintitle noneform"
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/maintitle_desktop.svg"),
      "alt": "生命有多麽地差異，世界有多麽地美麗"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "circleborder"
  })]), _vm._v(" "), _c('p', {
    staticClass: "graycolor"
  }, [_vm._v("用堅定的力量，與孩子共同學習成長")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "bluebg"
  }, [_c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/1.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/2.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/3.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/4.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/5.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/6.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/7.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/8.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/blue/9.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/3.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/7.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": require("../../img/index_menu/8.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menutxt",
    attrs: {
      "id": "m_01"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/about.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menutxt",
    attrs: {
      "id": "m_02"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/artist.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menutxt",
    attrs: {
      "id": "m_03"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/start.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menutxt",
    attrs: {
      "id": "m_04"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/support.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menutxt",
    attrs: {
      "id": "m_05"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/contact.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menutxt",
    attrs: {
      "id": "m_06"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/product.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maintitle nonefordesktop"
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/maintitle_m.svg"),
      "alt": "生命有多麽地差異，世界有多麽地美麗"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "graycolor"
  }, [_vm._v("用堅定的力量，與孩子共同學習成長")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748aad40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Kv.vue
// module id = 257
// module chunks = 0